import { NetworkSettings } from "@layerswap/widget/internal";
import { NetworkType } from "@layerswap/widget/types";
import { http, fallback } from 'viem';
import resolveChain from "./resolveChain";
const chainsToFilter = [70700, 70701];
export function getEvmChainsConfig(networks) {
    const isChain = (c) => c != undefined;
    const settingsChains = networks
        .slice()
        .sort((a, b) => (NetworkSettings.KnownSettings[a.name]?.ChainOrder || Number(a.chain_id)) - (NetworkSettings.KnownSettings[b.name]?.ChainOrder || Number(b.chain_id)))
        .filter(net => net.type === NetworkType.EVM
        && net.node_url
        && net.token
        && net.chain_id && !chainsToFilter.includes(Number(net.chain_id)))
        .map(resolveChain)
        .filter(isChain);
    const transports = {};
    settingsChains.forEach(chain => {
        const urls = chain.rpcUrls.default.http;
        transports[chain.id] = urls.length > 0 ? fallback(urls.map(url => http(url))) : http();
    });
    return {
        chains: settingsChains,
        transports,
    };
}
